import { render, staticRenderFns } from "./SubscriptionStatusBadge.vue?vue&type=template&id=6bf7ff0c&scoped=true"
import script from "./SubscriptionStatusBadge.vue?vue&type=script&lang=js"
export * from "./SubscriptionStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionStatusBadge.vue?vue&type=style&index=0&id=6bf7ff0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf7ff0c",
  null
  
)

export default component.exports